import { PropsWithChildren } from "react"
import classNames from "classnames"
import styled from "styled-components"

import { UITypes } from "types"

import { Breadcrumbs } from "../Breadcrumbs"

import styles from "./index.module.scss"

const Container = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1;
`

interface Props extends PropsWithChildren {
  title?: string
  breadcrumbs?: UITypes.Breadcrumb[]
  className?: string
}

export const ContentWrapper = ({ title, children, breadcrumbs, className }: Props) => {
  return (
    <Container className={classNames(styles.contentWrapper, className)}>
      {breadcrumbs && <Breadcrumbs list={breadcrumbs} />}
      <h2 className={styles.contentTitle}>{title}</h2>
      {children}
    </Container>
  )
}
